// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_Header__\\+n1BJ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
}
.Header_Header__\\+n1BJ .Header_headerElements__HfT66 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0 0 0;
}
.Header_Header__\\+n1BJ a {
  cursor: pointer;
  text-decoration: none;
}
.Header_Header__\\+n1BJ .Header_themeButton__8dnUA {
  width: 100vw;
  display: flex;
  justify-content: end;
  padding-bottom: 0.2rem;
  padding-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/views/Header/Header.module.scss"],"names":[],"mappings":"AAEA;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAFF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAFJ;AAKE;EACE,eAAA;EACA,qBAAA;AAHJ;AAKE;EACE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;AAHJ","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.Header {\n  $topPadding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n\n  .headerElements {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: $topPadding 0 0 0;\n  }\n\n  a {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  .themeButton {\n    width: 100vw;\n    display: flex;\n    justify-content: end;\n    padding-bottom: 0.2rem;\n    padding-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Header": `Header_Header__+n1BJ`,
	"headerElements": `Header_headerElements__HfT66`,
	"themeButton": `Header_themeButton__8dnUA`
};
export default ___CSS_LOADER_EXPORT___;
